import { render } from "./SqlEditor.vue?vue&type=template&id=b253b28a"
import script from "./SqlEditor.vue?vue&type=script&lang=js"
export * from "./SqlEditor.vue?vue&type=script&lang=js"

import "./SqlEditor.vue?vue&type=style&index=0&id=b253b28a&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__